<h3 class="ds-dsk-only fw-u3 mwl-sm-5">Locate your membership</h3>
<main class="fld-col ai-ctr ta-c">
  <img
    src="{{ cdnHost }}/img/mail-quackals.svg"
    alt="mail-quackals"
    class="fls-1-1 as-ctr mail-quackals"
  />

  <h2 class="fw-u3">
    Thank you! <br />
    Your membership has been located.
  </h2>

  <p>
    Please tap below to launch Home
  </p>
</main>

<footer>
  <button
    myqq-button
    class="raised"
    color="primary"
    (click)="goHome()"
    (keydown.enter)="$event.preventDefault()"
    (keyup.enter)="goHome()"
    aria-label="Go Home"
  >
    Home
  </button>
</footer>
